import { render, staticRenderFns } from "./PowerArea.vue?vue&type=template&id=66c69c4d&scoped=true&"
import script from "./PowerArea.vue?vue&type=script&lang=js&"
export * from "./PowerArea.vue?vue&type=script&lang=js&"
import style0 from "./PowerArea.vue?vue&type=style&index=0&id=66c69c4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c69c4d",
  null
  
)

export default component.exports